import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { scrollToTopOfPage } from 'utils/scrollToTopOfPage';

import { innskraningUrlEnum } from '../../stores/onboarding/data';
import { useInnskraningStore } from '../../stores/onboarding/useInnskraningStore';
import { useOnMount } from '../useOnMount';

export const useInnskraningOnMount = (callback?: () => void) => {
  const isLoggedIn = useInnskraningStore(useCallback((state) => state.isLoggedIn, []));
  const isCompleted = useInnskraningStore(useCallback((state) => state.isCompleted, []));
  const setScene = useInnskraningStore(useCallback((state) => state.setScene, []));

  const router = useRouter();

  useOnMount(() => {
    scrollToTopOfPage();

    if (!isLoggedIn || isCompleted) {
      router.push(innskraningUrlEnum.LOGIN, innskraningUrlEnum.LOGIN);
      setScene('initialScene', false);
    } else if (callback) {
      callback();
    }
  });
};
